import { createRouter, createWebHistory } from 'vue-router'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/bookings/:tripId',
      name: 'track',
      component: () => import('@/modules/tracking/pages/TrackingPage.vue'),
    },
    {
      // Short tracking link sent in pickup email/SMS; exchanges the code for a
      // token then redirects to the `track` route.
      path: '/s/:code',
      name: 'tracking-link',
      component: () => import('@/modules/tracking/pages/ShortLinkPage.vue'),
    },
    {
      path: '/:pathMatch(.*)*',
      name: 'not-found',
      component: () => import('@/app/pages/NotFoundPage.vue'),
    },
  ],
})

export default router
